module.exports = __webpack_public_path__ + "static/img/akum_600_80.8806c66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_80.svg
// module id = uYUl
// module chunks = 1